export default "__VITE_ASSET__11a6f0fd__"